import React from "react";
import { createRoot } from "react-dom/client";

import Container from "./container";

class CountryRegulationsTableApp {
  constructor(htmlNode, initialState) {
    createRoot(htmlNode).render(<Container {...initialState} />);
  }
}

export default CountryRegulationsTableApp;
